import TOKEN from '../TOKEN';

const createShrug =
  (context) =>
  ({ 0: text, index }) => ({
    type: TOKEN.SHRUG,
    text,
    index,
  });

createShrug.regex = /¯\\_\(ツ\)_\/¯$/g;

export default createShrug;
